import type { ReactNode } from "react";

import { TextField } from "@similarweb/ui-components/forms";

import { SettingSectionShell } from "./SettingSectionShell";

interface ISettingSectionProps {
    title: string;
    onValueChange: (value: string) => void;
    defaultValue?: string;
    fieldPlaceholder?: string;
    isDisabled?: boolean;
    autoFocus?: boolean;
    error?: string;
    children?: ReactNode;
}

export const InputSettingSection = ({
    title,
    onValueChange,
    defaultValue = "",
    fieldPlaceholder = "",
    isDisabled,
    autoFocus,
    error,
    children,
}: ISettingSectionProps) => (
    <SettingSectionShell
        title={title}
        field={
            <TextField
                defaultValue={defaultValue}
                onChange={onValueChange}
                placeholder={fieldPlaceholder}
                isInvalid={!!error}
                errorMessage={error}
                isDisabled={isDisabled}
                isReadOnly={isDisabled}
                autoFocus={autoFocus}
                data-automation="llm-edit-input-setting"
            />
        }
    >
        {children}
    </SettingSectionShell>
);
